var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"holidayguru"},[_c('div',{class:`hg-navbar-container ${
      _vm.navBorder ? 'hg-navbar-container__border' : ''
    }`},[_c('HgNavbar',{staticClass:"hg-navbar",attrs:{"lang":_vm.lang,"isMounted":_vm.mounted,"pathName":_vm.pathName},on:{"onClickBookmark":_vm.gotoBookmark,"onClickUser":_vm.gotoProfile}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }